/**
 * `push/token/` — Node-only feature, no Django counterpart. See
 * refactor/backend/src/modules/push/routes.ts.
 */
import { apiClient } from '../client';
import { PUSH_TOKEN } from './paths';

export async function registerPushToken(token: string): Promise<void> {
  await apiClient.post(PUSH_TOKEN, { token });
}

export async function unregisterPushToken(token: string): Promise<void> {
  await apiClient.delete(PUSH_TOKEN, { data: { token } });
}
